@if (facetItem) {
  <div class="p-2 border-bottom">
    <cat-facet-filter (valueChange)="onFilterValueChange($event)"></cat-facet-filter>
  </div>

  <ul class="flex-auto overflow-auto p-0 m-0 list-none" id="catalog_facet_wrp_facet-list">
    @for (field of registerFields$ | async; track field) {
      @if (facetItem.facets[field.fieldId] && facetItem.facets[field.fieldId].items.length > 0) {
        <li
          class="p-2 border-bottom last:border-b-0"
        >
          <div class="flex items-center">
            <button (click)="onToggleFacetCategory(field.fieldId)" mat-icon-button>
              <mat-icon>@if (facetItem.ui[field.fieldId]) {
                keyboard_arrow_down
              } @else {
                keyboard_arrow_right
              }</mat-icon>
            </button>
            <span
            >{{ field.fieldName }}
              @if (countChecked(facetItem.facets[field.fieldId].items) > 0) {
                <span
                >({{ countChecked(facetItem.facets[field.fieldId].items) }})</span
                >
              }</span
            >
          </div>
          @if (facetItem.ui[field.fieldId]) {
            @if (facetItem.facets[field.fieldId].stat.unique > facetItem.facets[field.fieldId].items.length) {
              <div class="pl-4 text-xs text-gray-400">{{
                  'catalog.facet.unique_value_count' | transloco: {
                    count: facetItem.facets[field.fieldId].items.length,
                    unique: facetItem.facets[field.fieldId].stat.unique
                  }
                }}
              </div>
            }
            <cdk-virtual-scroll-viewport
              [ngClass]="['viewport', 'viewport-' + facetItem.facets[field.fieldId].items.length]"
              itemSize="40"
            >
              <div *cdkVirtualFor="let item of facetItem.facets[field.fieldId].items; let j = index"
                   class="viewport-item">
                <cat-facet-list-item
                  (toggle)="onToggleFacet($event[0], $event[1])"
                  [fieldId]="field.fieldId"
                  [item]="item"
                ></cat-facet-list-item>
              </div>
            </cdk-virtual-scroll-viewport>
          }
        </li>
      }
    }
  </ul>
}

@if (isEmpty() && !filteredValue) {
  <div class="p-3 text-danger">
    {{ 'catalog.facet.no_filter_available' | transloco }}
  </div>
}

@if (isEmpty() && filteredValue) {
  <div class="p-3 text-danger">
    {{ 'catalog.facet.no_filter_available_value' | transloco : {value: filteredValue} }}
  </div>
}

<aipb-loading-progress [loading]="loading$ | async"></aipb-loading-progress>

<div class="p-2 border-top flex justify-between items-center">
  <button
    (click)="onResetFacetFilter()"
    [title]="'catalog.facet.clear' | transloco"
    class="mr-1 error-icon-button"
    id="catalog_facet_btn_reset-facet-filters"
    mat-icon-button
  >
    <mat-icon>delete</mat-icon>
  </button>

  <div>
    <button (click)="onNotSearch()" id="catalog_facet-list_btn_search-not" mat-button>
      <mat-icon>block</mat-icon>
      {{ facetItem?.notResultCount }}
    </button>
    <button
      (click)="onSearch()"
      [loading]="loading$ | async"
      class="primary-button"
      id="catalog_facet_btn_search-with-facet-filters"
      mat-flat-button
    >
      <mat-icon>search</mat-icon>
      {{ facetItem?.resultCount }}
    </button>
  </div>
</div>
